import { AjaxForm } from "@neonjungle/birdseed/forms/ajax";

export default function emailSubscribeForms() {
	const $subForms = document.querySelectorAll("[data-cm-signup-form]");
	$subForms.forEach($form => {
		let message = $form.querySelector("[data-cm-signup-form-message]");
		new AjaxForm($form, message);
	});
}
